/*
 *
 * Users reducer
 *
 */
import produce from "immer";
import {
  FLUSH_STATE,
  LOAD_USERS,
  LOAD_USERS_SUCCESS,
  LOAD_USERS_ERROR,
  UPDATE_USER,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_ERROR,
} from "./constants";

export const initialState = {
  firstRender: true,
  loading: false,
  error: false,
  loadingUpdate: false,
  userDetail: false,
  usersList: false,
  firstElem: false,
  actionType: "update",
};

/* eslint-disable default-case, no-param-reassign */
const usersReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case FLUSH_STATE:
        return initialState;

      case LOAD_USERS:
        draft.loading = true;
        draft.error = false;
        draft.firstRender = true;
        draft.usersList = false;
        draft.firstElem = false;
        break;

      case LOAD_USERS_SUCCESS:
        draft.loading = false;
        draft.firstRender = false;
        draft.usersList = action.usersList;
        draft.firstElem = draft.usersList.data[0];
        break;

      case LOAD_USERS_ERROR:
        draft.error = action.error;
        draft.loading = false;
        draft.firstRender = false;
        draft.usersList = false;
        draft.firstElem = false;
        break;

      // Update for Single User
      case UPDATE_USER:
        draft.firstRender = false;
        draft.loadingUpdate = false;
        draft.error = false;
        draft.userDetail = action.userDetail;
        draft.actionType = action.actionType;
        break;

      case UPDATE_USER_SUCCESS:
        draft.loadingUpdate = false;
        const { userDetail } = action;
        draft.userDetail = userDetail;
        if (userDetail?._id) {
          let listData = draft.usersList.data;
          let index = draft.usersList.data.findIndex(
            po => po._id === userDetail._id,
          );
          index !== -1
            ? (listData[index] = userDetail)
            : listData.unshift(userDetail);
          draft.usersList = { ...draft.usersList, data: listData };
          // console.debug(draft.usersList);
        } else if (userDetail?.code !== 200) {
          //notification.error({ message: userDetail?.message });
        }

        break;

      case UPDATE_USER_ERROR:
        draft.error = action.error;
        draft.loadingUpdate = false;
        break;
    }
  });

export default usersReducer;
